/**
 * Vue trackers
 */
/* eslint-disable no-var, one-var, vars-on-top, space-infix-ops, space-before-function-paren, comma-spacing */
import { isWebSite, isProdSite, getMatomoSiteId } from '@/helpers/deployment';
import { logErrorTrace } from '@/helpers';

/**
 * Matomo tracking (push to tracking queue)
 */
export const pushTXQ = (value) => {
    if (window._paq) {
        window._paq.push(value);
    }
};

export const plugin = {
    name: 'trackers',

    pushTXQ,

    install (Vue) {
        Vue.prototype.$pushTXQ = pushTXQ;


        // inject trackers to page after a short timeout to not compete with other assets
        setTimeout(() => {

            /**
             * Matomo
             */
            try {
                if (isWebSite && false) {

                    // Start Matomo Code
                    var _paq = window._paq = window._paq || [];
                    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
                    _paq.push(['trackPageView']);
                    _paq.push(['enableLinkTracking']);
                    (function() {
                        var u="https://taideart.matomo.cloud/";
                        _paq.push(['setTrackerUrl', u+'matomo.php']);
                        _paq.push(['setSiteId', getMatomoSiteId()]);
                        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                        g.type='text/javascript'; g.async=true; g.src='//cdn.matomo.cloud/taideart.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
                    })();
                    // End Matomo Code

                }
            }
            catch (error) {
                logErrorTrace(error, !isProdSite);
            }


            /**
             * Fonts.com usage counter tracking stylesheet (empty contents)
             * https://www.filamentgroup.com/lab/load-css-simpler/#the-code
             */
            try {
                if (isProdSite) {
                    (function() {
                        var d=document, h=d.createElement('link'), t=d.getElementsByTagName('link')[0];
                        h.rel='stylesheet'; h.type = 'text/css'; h.media='print';
                        h.href='//fast.fonts.net/t/1.css?apiType=css&projectid=7edd37f3-01d9-4a1a-8240-1f58dbf86e7e';
                        t.parentNode.insertBefore(h,t);
                    })();
                }
            }
            catch (error) {}

        }, 2000);
    }
};

export default plugin;
